<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <div v-if="address && address.length > 0">
          <b-tabs
            content-class="no-border"
            pills
            card
            vertical
            style="border: solid 1px #efefef; border-radius: 5px"
          >
            <b-tab
              v-for="(obj, index) in address"
              :key="index"
              :title="(index + 1).toString()"
              class="no-border"
            >
              <div class="form-group row">
                <div class="col-md-12">
                  <label><strong>Endereço</strong></label>
                  <div class="input-group">{{ obj.logradouro }}</div>
                </div>
              </div>
              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Complemento</strong></label>
                  <div class="input-group">{{ obj.complemento }}</div>
                </div>
                <div class="col-md-6">
                  <label><strong>Número</strong></label>
                  <div class="input-group">{{ obj.numero }}</div>
                </div>
              </div>
              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Bairro</strong></label>
                  <div class="input-group">{{ obj.bairro }}</div>
                </div>
                <div class="col-md-6">
                  <label><strong>Cep</strong></label>
                  <div class="input-group">{{ formatCep(obj.cep) }}</div>
                </div>
              </div>
              <div class="form-group row pt-2">
                <div class="col-md-6">
                  <label><strong>Cidade</strong></label>
                  <div class="input-group">{{ obj.municipio }}</div>
                </div>
                <div class="col-md-6">
                  <label><strong>UF</strong></label>
                  <div class="input-group">{{ obj.uf }}</div>
                </div>
              </div>
              <div
                v-if="obj.enderecoCorrespondencia"
                class="form-group row pt-2"
              >
                <div class="col-md-12">
                  <label><strong>Endereço de correspondência</strong></label>
                  <div class="input-group">
                    {{ obj.enderecoCorrespondencia }}
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-else-if="address && address.length === 0 && cardActive">
          Nenhum registro de endereço,
          <strong
            @click="onNewAddress"
            style="cursor: pointer"
            >clique para adicionar</strong
          >
        </div>
        <!-- <div v-else>
            <div class="form-group row pt-3">
              <div class="col-md-12">
                <label><strong>Endereço</strong></label>
                <div class="input-group"></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-6">
                <label><strong>Complemento</strong></label>
                <div class="input-group"></div>
              </div>
              <div class="col-md-6">
                <label><strong>Número</strong></label>
                <div class="input-group"></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label><strong>Bairro</strong></label>
                <div class="input-group"></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-6">
                <label><strong>Cidade</strong></label>
                <div class="input-group"></div>
              </div>
              <div class="col-md-6">
                <label><strong>UF</strong></label>
                <div class="input-group"></div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label><strong>Endereço de correspondência</strong></label>
                <div class="input-group"></div>
              </div>
            </div>
          </div> -->
      </div>
    </div>
    <ModalAddress
      ref="ModalAddress"
      :card="card"
      v-on:Reload="onReload"
    />
  </div>
</template>
<script>
import CrmDetailsAddress from './address.js'
export default CrmDetailsAddress
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}
</style>
<style scoped>
.no-border {
  border: 0px;
}
.tab-content {
  border: 0px solid #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/addresses/address.vue